import gsap from 'gsap'
import { Flip } from 'gsap/Flip'

gsap.registerPlugin(Flip)

class ServicesBanner {
  constructor(el) {
    this.el = el
    this.video = this.el.querySelector('.intro-alt__asset')

    if (!this.video) return

    document.fonts.ready.then(() => {
      this.expandVideo()
    })
  }
  expandVideo() {
    if (window.innerWidth <= 1024) return

    const state = Flip.getState('.intro-alt__asset-holder, .intro-alt__asset-target')
    const video = this.el.querySelector('.intro-alt__asset')
    const container = this.el.querySelector('.container')

    Flip.to(state, {
      simple: true,
      absolute: true,
      scrollTrigger: {
        trigger: this.el,
        start: 'top top-=150px',
        end: 'bottom bottom',
        scrub: 1
      }
    })

    gsap.fromTo(
      video,
      {
        // scale: 3
      },
      {
        // scale: 1,
        scrollTrigger: {
          trigger: this.el,
          start: 'top top-=150px',
          end: 'bottom bottom',
          scrub: 1
        }
      }
    )

    gsap.to(video, {
      y: 300,
      ease: 'none',
      scrollTrigger: {
        trigger: this.el,
        start: 'bottom bottom',
        end: 'bottom top',
        scrub: 0
      }
    })

    // gsap.to(container, {
    //   y: 300,
    //   ease: 'none',
    //   scrollTrigger: {
    //     trigger: this.el,
    //     start: 'bottom bottom',
    //     end: 'bottom top',
    //     scrub: 0
    //   }
    // })
  }
}

export const initServicesBanner = () => {
  const banner = document.querySelector('.intro-alt')
  if (banner) new ServicesBanner(banner)
}

export default () => {}
